
import axios from 'axios'
import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'



export default {
    namespaced: true,
    // data sample
    // [
    //     {
    //         "id": 1,
    //         "title": "ทดสอบ",
    //         "content_html": "<p><strong>test</strong></p><p><br></p><p><br></p><p><strong>test2</strong></p><p><br></p><p><br></p><p><br></p><p><em>test4</em></p>",
    //         "content_txt": "test\n\n\n\n\n\n\n\ntest2\n\n\n\n\n\n\n\n\n\n\ntest4"
    //     }
    //     ]
    state: {
        myTemplate: [],
        myTemplate1 : "test myTemplate"
    },

    getters: {

    },

    mutations: {
        setMyTemplate (state, myTemplate) {
            state.myTemplate = myTemplate
        },

    },

    actions: {

        fetchMytemplate({commit},payload) {
            const dat = {
                "user" : payload.user_id
            }
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
            return  new Promise( (resolve,reject)=> {
                    axios.post(`${getBaseURLforBackEnd()}/api/listoflabnonautomate_templete`,dat,getConfigAxios())
                        .then(res=>{
                            commit('setMyTemplate', res.data)
                            resolve(res)
                        })
                        .catch(err=>{
                            reject(err)
                        })
                }
            );
        },
    }
}